import { useSelector } from 'react-redux'
import React from 'react'
import AppBar from '@mui/material/AppBar'
import Toolbar from '@mui/material/Toolbar'
import MenuIcon from '@mui/icons-material/Menu'

import useStyles from '../../app/Styles'
import {
    Avatar,
    Box,
    IconButton,
    List,
    ListItem,
    ListItemText,
    Popover,
    useMediaQuery,
    Divider
} from '@mui/material'
import appActions from '../../app/actions'
import { USER_PROP } from 'pages/User/constants'
import HeaderView from './HeaderView'
import { Link } from 'react-router-dom'
import { mobileUserSettings } from '../../app/constants'
import { getAuthorizedRoutes } from '../../app/Validations'

const HeaderContainer = () => {
    const { loggedIn, role } = useSelector((state) => state.auth)
    const { user } = useSelector((state) => state.auth)

    const { setDrawerState } = appActions()

    const classes = useStyles()
    const [anchorEl, setAnchorEl] = React.useState(null)

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget)
    }

    const handleClose = () => {
        setAnchorEl(null)
    }
    const matches = useMediaQuery((theme) => theme.breakpoints.up('sm'))

    const open = Boolean(anchorEl)
    const id = open ? 'user-settings' : null

    return loggedIn ? (
        <AppBar
            position="fixed"
            elevation={0}
            className={matches ? classes.appBar : ''}
            color="transparent"
        >
            <Toolbar className={classes.toolbar}>
                {!matches && <HeaderView />}

                <Box className={classes.toolbarButtons}>
                    {matches ? (
                        <Avatar
                            alt="Logo"
                            className={classes.AvatarSmall}
                            aria-describedby={id}
                            onClick={handleClick}
                            sx={{backgroundColor:'#0a396a'}}
                        >
                            {(user.firstname.toUpperCase()[0] || '') +
                                (user.lastname.toUpperCase()[0] || '')}
                        </Avatar>
                    ) : (
                        <IconButton
                            edge="start"
                            className={classes.menuButton}
                            onClick={() => setDrawerState()}
                            color="inherit"
                            aria-label="menu"
                        >
                            <MenuIcon />
                        </IconButton>
                    )}
                </Box>
                <Popover
                    id={id}
                    open={open}
                    anchorEl={anchorEl}
                    onClose={handleClose}
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'center',
                    }}
                    transformOrigin={{
                        vertical: 'top',
                        horizontal: 'center',
                    }}
                >
                    <List disablePadding>
                        <ListItem>
                            <ListItemText primary={`${user.firstname} ${user.lastname}`} secondary={user.email} />
                        </ListItem>
                        <Divider />
                        {getAuthorizedRoutes(
                            mobileUserSettings,
                            loggedIn,
                            role,
                        ).map((link) => (
                            <ListItem
                                button
                                key={link.route}
                                component={Link}
                                to={link.route}
                            >
                                <ListItemText primary={link.text} />
                            </ListItem>
                        ))}
                    </List>
                </Popover>
            </Toolbar>
        </AppBar>
    ) : (
        <AppBar position="fixed" elevation={0} color="transparent">
            <Toolbar className={classes.toolbar}>
                <Box p={1}>
                    <HeaderView />
                </Box>
            </Toolbar>
        </AppBar>
    )
}

export default HeaderContainer
